/* eslint-disable react/display-name */
import React, { createContext } from "react"

const MicrocopyContext = createContext()

/**
 * A microcopy provider that is wrapper around
 * entire layouts to provide a new microcopy context
 */
const MicrocopyProvider = ({ microcopy, children }) => (
  <MicrocopyContext.Provider value={microcopy}>
    {children}
  </MicrocopyContext.Provider>
)

/**
 * A helper method for quickly wrapping any component
 * with the microcopy
 */
const withMicrocopy = (WrappedComponent) => (props) => (
  <MicrocopyContext.Consumer>
    {(microcopy) => <WrappedComponent {...props} microcopy={microcopy} />}
  </MicrocopyContext.Consumer>
)

export default MicrocopyContext
export { MicrocopyProvider, withMicrocopy }
